import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./style.css";
import { initializeWeatherServices } from "./services/weather.service";

// Initialize weather services with web HTTP adapter
initializeWeatherServices({
  synopticAPIKey: import.meta.env.VITE_SYNOPTIC_API_KEY,
  synopticBaseUrl: import.meta.env.VITE_SYNOPTIC_BASE_URL,
  firebaseAPIKey: import.meta.env.VITE_FIREBASE_API_KEY,
  openMeteoBaseUrl: import.meta.env.VITE_OPEN_METEO_PRIMARY_BASE_URL,
  openMeteoApiKey: import.meta.env.VITE_OPEN_METEO_API_KEY,
});

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.mount("#app");
